import { render, staticRenderFns } from "./TributeMusicTable.vue?vue&type=template&id=50ddb8b6"
import script from "./TributeMusicTable.vue?vue&type=script&lang=js"
export * from "./TributeMusicTable.vue?vue&type=script&lang=js"
import style0 from "./TributeMusicTable.vue?vue&type=style&index=0&id=50ddb8b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports